export default function Partnership() {
  const items = [
    {
      icon: 'ri-gift-line',
      title: '0元一頁式網站為「建置服務免費」',
      color: 'teal'
    },
    {
      icon: 'ri-global-line',
      title: '上線需由客戶負擔必需之第三方成本：',
      color: 'blue',
      subItems: [
        '網域註冊費（每年）',
        '網站代管/主機與基本維運費（每年）'
      ]
    },
    {
      icon: 'ri-calendar-check-line',
      title: '本服務需搭配年度管理訂閱方案',
      color: 'purple'
    },
    {
      icon: 'ri-shield-check-line',
      title: '訂閱期間內，網站可持續上線、代管與基本維運',
      color: 'green'
    },
    {
      icon: 'ri-database-2-line',
      title: '若未續約，網站將下線，資料無法匯出',
      color: 'orange'
    }
  ];

  return (
    <section id="partnership" className="py-24 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            合作方式說明
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
        </div>

        <div className="space-y-5">
          {items.map((item, index) => (
            <div 
              key={index}
              className="bg-gradient-to-r from-gray-50 to-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300"
            >
              <div className="flex items-start">
                <div className={`w-12 h-12 bg-${item.color}-100 rounded-lg flex items-center justify-center flex-shrink-0`}>
                  <i className={`${item.icon} text-xl text-${item.color}-600`}></i>
                </div>
                <div className="ml-5 flex-1">
                  <p className="text-base md:text-lg text-gray-800 font-medium leading-relaxed">
                    {item.title}
                  </p>
                  {item.subItems && (
                    <ul className="mt-3 space-y-2 ml-4">
                      {item.subItems.map((subItem, subIndex) => (
                        <li key={subIndex} className="flex items-center text-sm text-gray-600">
                          <i className="ri-arrow-right-s-line text-teal-500 mr-2"></i>
                          {subItem}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-8 md:p-10 text-white shadow-lg">
          <div className="flex items-start">
            <i className="ri-hand-heart-line text-4xl mr-4 flex-shrink-0"></i>
            <div>
              <h3 className="text-xl md:text-2xl font-bold mb-3">我們的承諾</h3>
              <p className="text-base md:text-lg leading-relaxed opacity-95">
                <i className="ri-arrow-right-line mr-2"></i>
                我們不會做一次交付就消失的案子
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
